const Datepicker = require('./datepicker.js');

module.exports = {
  install (Vue) {
    Vue.component(Datepicker.componentName, Datepicker);
  }
};



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/components/datepicker/index.js